// extracted by mini-css-extract-plugin
export default {"SearchPanel":"pj_a bhk_ea bhk_kb bhk_js bhk_a bhk_j bhk_sm bhk_sn","SearchPanel__icon":"pj_b bhk_vm bhk_hg bhk_ss bhk_uy","SearchPanel__input":"pj_c bhk_iz bhk_eb bhk_z"};